import { string, arrayOf, object } from "prop-types";
import React from "react";

import { Trans, useTranslation } from "@lib/i18n";

const getLinksArray = links => {
  if (Array.isArray(links)) {
    return links;
  }

  if (typeof links === "string") {
    return [links];
  }

  if (links && typeof links === "object") {
    // i18next can return an indexed object instead of an array
    return Object.keys(links)
      .sort((a, b) => Number(a) - Number(b))
      .map(key => links[key]);
  }

  return [];
};

const getLinkValues = links => {
  const values = links.reduce(
    (acc, link, index) => ({ ...acc, [`link${index}`]: link || "" }),
    {}
  );

  const [firstLink] = links.filter(Boolean);

  if (firstLink) {
    values.link = firstLink;
  }

  return values;
};

const getLinkComponents = links =>
  links.map((link, linkIndex) =>
    link ? (
      <a
        className="text-primaryOrange underline"
        href={link}
        key={linkIndex}
        target="_blank"
        rel="noopener noreferrer"
      />
    ) : (
      <React.Fragment key={linkIndex} />
    )
  );

const QuestionList = ({ questions, title, section }) => {
  const { t } = useTranslation();

  return (
    <ul className="my-4" data-id={`question-${title}-content`}>
      {questions.map(({ links }, questionIndex) => {
        const baseKey = `footer.faq.sections.${section}.questions.${questionIndex}`;
        const question = `${baseKey}.question`;
        const answer = `${baseKey}.answer`;

        if (!t(question) && !t(answer)) {
          return null;
        }

        const linksArray = getLinksArray(links);

        return (
          <li key={questionIndex}>
            <h5 className="text-base font-semibold">
              <Trans i18nKey={question} />
            </h5>
            <p className="m-0 pb-4">
              <Trans
                components={getLinkComponents(linksArray)}
                i18nKey={answer}
                values={getLinkValues(linksArray)}
              />
            </p>
          </li>
        );
      })}
    </ul>
  );
};

QuestionList.propTypes = {
  questions: arrayOf(object),
  title: string,
  section: string,
};

export default QuestionList;
